const compareArray = (arr1, arr2) => {
  if (!arr1 || !arr2) {
    return false;
  }

  if (arr1.length !== arr2.length) {
    return false;
  }

  //Iterate through all elements in first array
  for (let x = 0; x < arr1.length; x++) {
    if (arr1[x][0] !== arr2[x][0] || arr1[x][1] !== arr2[x][1]) {
      return false;
    }
  }

  return true;
};

export default compareArray;
